/**
 * Config for ReduxToastr component
 *
 * init - props for ReduxToastr component
 */

module.exports = {
    toastr: {
        init: {
            timeOut: 5000,
            position: 'bottom-right',
            transitionIn: 'fadeIn',
            transitionOut: 'fadeOut',
            newestOnTop: false,
        },
    },
}
